module.exports = __webpack_public_path__ + "static/wire-product-2-e75532f0023dfd8b3d3d6273a968e018.png";